import { normalizeExternalProfileUrl } from "../../utils/externalProfileUrl";

export const PROFILE_SOCIAL_KEYS = [
    "website",
    "instagram",
    "tiktok",
    "twitter",
    "youtube",
];

function getProfileField(profileData, key) {
    const nestedDetails =
        profileData?.socialDetails &&
        typeof profileData.socialDetails === "object" &&
        !Array.isArray(profileData.socialDetails)
            ? profileData.socialDetails
            : {};
    const value = nestedDetails[key] ?? profileData?.[key];
    return typeof value === "string" ? value.trim() : "";
}

export function buildProfileAboutData(profileData = {}) {
    const bio = getProfileField(profileData, "bio");
    const links = PROFILE_SOCIAL_KEYS.reduce((result, key) => {
        const href = normalizeExternalProfileUrl(getProfileField(profileData, key));
        if (href) result[key] = href;
        return result;
    }, {});

    return { bio, links };
}
